export default __webpack_public_path__ + "static/media/Bandhavgarh_ElephantFamily.62c50041.jpg";